<c-container class="mt-5">

  <h2>Charity Payouts</h2>

  @if (isCrossGame) {
    <app-choose-your-game [message]="'Choose a game to view its charity payouts'"
                          (gameChosenEvent)="onGameChosen($event)"></app-choose-your-game>
  }

  @if (game) {
    <app-charity-payouts [gameSetter]="{ gameP: game, isCrossGame: isCrossGame }"></app-charity-payouts>
  }

</c-container>
